/* eslint-disable @typescript-eslint/no-shadow */

'usestrict';

xplenty.directive('bindHtmlCompile', [
  '$compile',
  function ($compile) {
    return function (scope, element, attrs) {
      scope.$watch(
        function (scope) {
          return scope.$eval(attrs.bindHtmlCompile);
        },
        function (value) {
          element.html(value);
          $compile(element.contents())(scope);
        },
      );
    };
  },
]);
